import filterOutUndefined from "../../../Core/filterOutUndefined";
import { isJsonObject, isJsonString } from "../../../Core/Json";

/** A range of values of a numeric parameter. This range can be continuous or discrete, defined by a fixed spacing between adjacent valid values. If the MinimumValue or MaximumValue is not included, there is no value limit in that direction. Inclusion of the specified minimum and maximum values in the range shall be defined by the rangeClosure. */

export function parseOwsKeywordList(json) {
  if (!isJsonObject(json)) return undefined;
  const type = isJsonString(json.type) ? json.type : undefined;
  const Keyword = isJsonString(json.Keyword) ? json.Keyword : Array.isArray(json.Keyword) ? filterOutUndefined(json.Keyword.map(s => isJsonString(s) ? s : undefined)) : [];
  return {
    type,
    Keyword
  };
}
export function parseOnlineResource(json) {
  if (!isJsonObject(json)) return undefined;
  const href = isJsonString(json["xlink:href"]) ? json["xlink:href"] : undefined;
  if (href === undefined) return;
  const type = isJsonString(json["xlink:type"]) ? json["xlink:type"] : undefined;
  return {
    "xlink:type": type,
    "xlink:href": href
  };
}